// Canonical form for a POTA reference so that a QSO's potaRef, a CSV Reference, and a
// spot's reference all compare equal regardless of case or surrounding whitespace.
export function normalizeReference(ref: string | null | undefined): string {
  return (ref ?? '').trim().toUpperCase();
}

// A single field can carry multiple parks (a "2-fer"), stored comma-joined - e.g. a QSO's
// potaRef "US-1,US-2" (HAMRS/ADIF) or a CSV Reference cell. Split into normalized,
// non-empty, UNIQUE refs so each park is credited exactly once even if the field repeats a
// ref or varies only by case ("US-1,us-1").
export function splitReferences(value: string | null | undefined): string[] {
  const unique = new Set<string>();
  for (const part of (value ?? '').split(',')) {
    const ref = normalizeReference(part);
    if (ref) unique.add(ref);
  }
  return [...unique];
}
